var _rect, _path, _path2, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 310,
    viewBox: "0 0 350 310",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 309.677,
    fill: "tranparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 27C48.5 30 83.4 42.8 83 70C82.6 97.2 82.8333 145 83 165.5C83.6667 177 94 200.5 130 202.5C166 204.5 256.667 203.333 297.5 202.5",
    stroke: "#F1CA5E",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 68.9989H283.5C298 68.6656 318.578 76.5 309 102.499C298.5 131 286.5 171 248 168.499H85.5",
    stroke: "#F1CA5E",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 114H173.5",
    stroke: "#F1CA5E",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 258.5,
    r: 22.5,
    stroke: "#F1CA5E",
    strokeWidth: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 258.5,
    r: 22.5,
    stroke: "#F1CA5E",
    strokeWidth: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/Basket.de8441d605e3da5af6a72aa24552915e.svg";
export { ForwardRef as ReactComponent };